import Axios from "axios";
import AuthAction from "../Actions/AuthActions";
import GeneralAction from "../Actions/GeneralAction";
import Apis from "../Apis";
import AlertAction from "../Actions/AlertActions";
import { getHeaders } from "../../utills";

class AuthMiddleware {
  static Login = (userData) => {
    return (dispatch) => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("email", userData?.email);
          formdata.append("password", userData?.password);
          // formdata.append('device_id', userData?.DeviceToken);
          formdata.append("role", userData?.role);
          const { data } = await Axios.post(Apis.login, formdata);
          if (data?.success) {
            localStorage.setItem("token", data?.data?.token);
            localStorage.setItem("@user", JSON.stringify(data?.data));
            localStorage.setItem("role", data?.data?.role);
            dispatch(
              AuthAction.isLogin({ isLogin: true, userData: data?.data })
            );
            dispatch(GeneralAction.HideLoading());
          } else {
            dispatch(GeneralAction.HideLoading());
            dispatch(
              AlertAction.ShowAlert({ type: "error", message: data?.message })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            AlertAction.ShowAlert({ type: "error", message: "Network error" })
          );
          console.log(error);
          dispatch(GeneralAction.HideLoading());
        }
      });
    };
  };

  static LoginUpdateStatus = (userData) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("is_online", userData?.status);
          const { data } = await Axios.post(Apis.updateOnlineStatus, formdata, {
            headers: getHeaders(),
          });
          if (data?.success) {
            localStorage.setItem("@user", JSON.stringify(userData?.user));
            dispatch(AuthAction.getUser(userData?.user));
            console.log("data======>", data?.message);
          }
        } catch (error) {
          reject(error);
          dispatch(
            AlertAction.ShowAlert({ type: "error", message: "Network error" })
          );
          console.log(error);
        }
      });
    };
  };

  static SignUp = (userData) => {
    return (dispatch) => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("first_name", userData?.First_Name);
          formdata.append("last_name", userData?.Last_Name);
          formdata.append("email", userData?.email);
          formdata.append("password", userData?.password);
          formdata.append("confirm_password", userData?.Confirm_Password);
          // formdata.append('device_id', userData?.DeviceToken);
          for (const [i, document] of userData?.MultipleAddress.entries()) {
            formdata.append(`addresses[${i}][address]`, document?.address);
            formdata.append(`addresses[${i}][lat]`, document?.lat);
            formdata.append(`addresses[${i}][lng]`, document?.lng);
          }
          const { data } = await Axios.post(Apis.signup, formdata);
          if (data?.success) {
            resolve(data);
            dispatch(GeneralAction.HideLoading());
            dispatch(
              AlertAction.ShowAlert({ type: "success", message: data?.message })
            );
          } else {
            dispatch(GeneralAction.HideLoading());
            dispatch(
              AlertAction.ShowAlert({ type: "error", message: data?.message })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            AlertAction.ShowAlert({ type: "error", message: "Network error" })
          );
          console.log(error);
          dispatch(GeneralAction.HideLoading());
        }
      });
    };
  };

  static getUserInfo = () => {
    return dispatch => {
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await Axios.get(
            Apis.getUserInfo,
            {
              headers: getHeaders(),
            }
          );
          if (data?.success) {
            localStorage.setItem('@user', JSON.stringify(data?.data));
            dispatch(AuthAction.getUser(data?.data));
          } else {
            dispatch(
              AlertAction.ShowAlert({ type: "error", message: data?.message })
            );
          }
        } catch (error) {
          reject(error);
          console.log(error);
        }
      });
    };
  }


  static UpdateProfile = (userData) => {
    return (dispatch) => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();

          if (userData?.pickImage) {
            formdata.append("profile_image", userData?.pickImage);
          }
          formdata.append("first_name", userData?.Firstname);
          formdata.append("last_name", userData?.Lastname);
          formdata.append("contact_no", userData?.ContactNumber);
          for (const [i, document] of userData?.MultipleAddress.entries()) {
            formdata.append(`addresses[${i}][address]`, document?.address);
            formdata.append(`addresses[${i}][lat]`, document?.lat);
            formdata.append(`addresses[${i}][lng]`, document?.lng);
            formdata.append(`addresses[${i}][address_id]`, document?.id);
          }
          formdata.append("category_id", userData?.selectedCategory);
          // userData?.StartTime
          //   ? formdata.append("working_start_time", userData?.StartTime)
          //   : formdata.append("working_start_time", null);
          // userData?.EndTime
          //   ? formdata.append("working_end_time", userData?.EndTime)
          //   : formdata.append("working_end_time", null);
          // formdata.append('profile_image', null);

          const { data } = await Axios.post(Apis.updateProfile, formdata, {
            headers: getHeaders(),
          });
          if (data?.success) {
            resolve(data);
            localStorage.setItem("@user", JSON.stringify(data?.data));
            dispatch(AuthAction.getUser(data?.data));
            dispatch(GeneralAction.HideLoading());
          } else {
            dispatch(GeneralAction.HideLoading());
            dispatch(
              AlertAction.ShowAlert({ type: "success", message: data?.message })
            );
            // Alert.alert('Note', data?.message);
          }
        } catch (error) {
          reject(error);
          dispatch(
            AlertAction.ShowAlert({ type: "warning", message: "Network Error" })
          );
          // alert('Network Error');
          dispatch(GeneralAction.HideLoading());
        }
      });
    };
  };

  static ForgotPassword = (userData) => {
    return (dispatch) => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("email", userData?.Email);
          const { data } = await Axios.post(Apis.forgot_password, formdata);
          if (data?.success) {
            resolve(data);
            dispatch(GeneralAction.HideLoading());
          } else {
            dispatch(GeneralAction.HideLoading());
            // Alert.alert('Note', data?.message);
            dispatch(
              AlertAction.ShowAlert({ type: "warning", message: data?.message })
            );
          }
        } catch (error) {
          reject(error);
          alert("Network Error");
          console.log(error);
          dispatch(GeneralAction.HideLoading());
        }
      });
    };
  };

  static ConfirmPassword = (userData) => {
    return (dispatch) => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("email", userData?.Email);
          formdata.append("password", userData?.Password);
          formdata.append("confirm_password", userData?.ConfirmPassword);

          const { data } = await Axios.post(Apis.change_password, formdata);
          if (data?.success) {
            resolve(data);
            dispatch(GeneralAction.HideLoading());
          } else {
            dispatch(GeneralAction.HideLoading());
            // Alert.alert('Note', data?.message);
            dispatch(
              AlertAction.ShowAlert({ type: "warning", message: data?.message })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            AlertAction.ShowAlert({ type: "warning", message: "Network Error" })
          );
          console.log(error);
          dispatch(GeneralAction.HideLoading());
        }
      });
    };
  };

  static deleteAddress = id => {
    return dispatch => {
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append('id', id);
          const { data } = await Axios.post(
            Apis.deleteAddress,
            formdata,
            { headers: getHeaders() }
          );
          if (data?.success) {
            localStorage.setItem('@user', JSON.stringify(data?.data));
            dispatch(AuthAction.getUser(data?.data));
            AlertAction.ShowAlert({ type: "success", message: data.message })
          }
        } catch (error) {
          reject(error);
          AlertAction.ShowAlert({ type: "error", message: 'Network Error' })
        }
      });
    };
  };

  static updatePassword = (userData) => {
    return (dispatch) => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("old_password", userData?.old_password);
          formdata.append("new_password", userData?.new_password);
          formdata.append("confirm_password", userData?.confirm_password);

          const { data } = await Axios.post(Apis.updatePassword, formdata, {
            headers: getHeaders(),
          });
          if (data?.success) {
            resolve(data);
            dispatch(GeneralAction.HideLoading());
          } else {
            dispatch(GeneralAction.HideLoading());
            dispatch(
              AlertAction.ShowAlert({ type: "warning", message: data?.message })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            AlertAction.ShowAlert({ type: "warning", message: "Network Error" })
          );
          console.log(error);
          dispatch(GeneralAction.HideLoading());
        }
      });
    };
  };

  static Logout = () => {
    return (dispatch) => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await Axios.get(Apis.logout, {
            headers: getHeaders(),
          });
          if (data?.success) {
            dispatch(AuthAction.isLogin({ isLogin: false, userData: null }));
            localStorage.clear();
            dispatch(GeneralAction.HideLoading());
            resolve(data);
          } else {
            dispatch(GeneralAction.HideLoading());
            dispatch(
              AlertAction.ShowAlert({ type: "warning", message: data?.message })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            AlertAction.ShowAlert({ type: "error", message: "Network error" })
          );
          console.log(error);
          dispatch(GeneralAction.HideLoading());
        }
      });
    };
  };
  static DeleteAccount = () => {
    return (dispatch) => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await Axios.post(
            Apis.deleteAccount,
            {},
            await getHeaders()
          );
          if (data?.success) {
            await localStorage.clearStorage();
            dispatch(AuthAction.getUser(null));
            dispatch(AuthAction.isLogin(false));
            dispatch(GeneralAction.HideLoading());
          } else {
            dispatch(GeneralAction.HideLoading());
            dispatch(
              AlertAction.ShowAlert({ type: "warning", message: data?.message })
            );
            // Alert.alert('Note', data?.message);
          }
        } catch (error) {
          reject(error);
          dispatch(
            AlertAction.ShowAlert({ type: "warning", message: "Network error" })
          );
          // alert('Network error');
          console.log(error);
          dispatch(GeneralAction.HideLoading());
        }
      });
    };
  };
}

export default AuthMiddleware;
